import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import FadeIn from '../Transitions/FadeIn'
import SydButton from '../../commonDesign/Button'

const useStyles = makeStyles(theme => ({
  errorDisplay: {
    width: '100%',
    border: 'var(--border-danger-normal)',
    borderRadius: 'var(--border-radius-md)',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.layout.gap.g20,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '10vh',
    '&.__error-content': {
      fontSize: theme.typography.fontSizes.xxl
    },
    '&.__value': {
      paddingLeft: theme.layout.padding.p5
    }
  },
  softErrorDisplay: {
    border: 'none'
  }
}))

const ErrorDisplay = ({ error, onRetry, soft = false }) => {
  const classes = useStyles()
  const message = useMemo(() => {
    if (error?.response?.message) {
      return error.response.message
    }

    return error.toString()
  }, [error])
  const errorClassName = clsx(
    classes.errorDisplay,
    soft && classes.softErrorDisplay
  )
  return (
    <FadeIn className={errorClassName}>
      <div className='__error-content'>
        {message}
      </div>
      {onRetry ? (
        <div className='__error-actions'>
          <SydButton variant='primary' priority='warning' onClick={onRetry} icon='sync'>Retry</SydButton>
        </div>
      ) : null}
    </FadeIn>
  )
}

ErrorDisplay.propTypes = {
  error: PropTypes.any,
  onRetry: PropTypes.func,
  soft: PropTypes.bool
}

export default ErrorDisplay
